import React, { memo } from 'react'
import { Pagination } from 'antd'

const AppPagination = paginationProps => {
  return (
    <Pagination
      hideOnSinglePage={false}
      showLessItems
      showSizeChanger={true}
      {...paginationProps}
    />
  )
}

export default memo(AppPagination)
